import { render } from "./Loader.htm?vue&type=template&id=742e0090&scoped=true"
import script from "./Loader.js?vue&type=script&lang=js"
export * from "./Loader.js?vue&type=script&lang=js"

import "./Loader.scss?vue&type=style&index=0&id=742e0090&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742e0090"]])

export default __exports__